import React, { useState } from "react";

const API = "https://live-evo.com/api";

function AdminToolsWebPage() {
  const [loadingAction, setLoadingAction] = useState(null);

  const runTool = async (tool) => {
    try {
      setLoadingAction(tool);

      if (tool === "ping") {
        const res = await fetch(`${API}/ping`);
        const data = await res.json();
        alert("API OK\n" + JSON.stringify(data, null, 2));
      }

      if (tool === "stats") {
        const res = await fetch(`${API}/coins/admin/stats`);
        const data = await res.json();
        alert("Stats OK\n" + JSON.stringify(data, null, 2));
      }

      if (tool === "users") {
        const res = await fetch(`${API}/coins/admin/users`);
        const data = await res.json();
        alert(`Users OK\n${Array.isArray(data) ? data.length : 0} utilisateurs trouvés`);
      }

      if (tool === "transactions") {
        const res = await fetch(`${API}/coins/admin/transactions`);
        const data = await res.json();
        alert(`Transactions OK\n${Array.isArray(data) ? data.length : 0} transactions trouvées`);
      }
    } catch (err) {
      console.error("Erreur outil admin:", err);
      alert("Action impossible ou route backend absente");
    } finally {
      setLoadingAction(null);
    }
  };

  const ToolButton = ({ title, desc, icon, tool }) => (
    <div
      onClick={() => runTool(tool)}
      style={{
        background: "#051626",
        border: "1px solid #1a2b3c",
        borderRadius: 12,
        padding: 15,
        marginBottom: 12,
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      }}
    >
      <div style={{ fontSize: 24, marginRight: 12 }}>{icon}</div>

      <div style={{ flex: 1 }}>
        <div style={{ color: "#fff", fontWeight: "bold", fontSize: 14 }}>
          {title}
        </div>
        <div style={{ color: "#8fa6ad", fontSize: 12, marginTop: 3 }}>
          {desc}
        </div>
      </div>

      <div style={{ color: "#00f2ff", fontSize: 22, fontWeight: "bold" }}>
        {loadingAction === tool ? "..." : "›"}
      </div>
    </div>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020b14",
        padding: 18,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h1
          style={{
            color: "#00f2ff",
            fontSize: 22,
            fontWeight: "bold",
            marginBottom: 18,
            textAlign: "center"
          }}
        >
          ⚙️ OUTILS ADMIN
        </h1>

        <ToolButton icon="🟢" title="Tester API" desc="Vérifie /api/ping" tool="ping" />
        <ToolButton icon="📊" title="Tester Stats" desc="Vérifie /coins/admin/stats" tool="stats" />
        <ToolButton icon="👥" title="Tester Users" desc="Vérifie /coins/admin/users" tool="users" />
        <ToolButton icon="💰" title="Tester Transactions" desc="Vérifie /coins/admin/transactions" tool="transactions" />

        <div
          style={{
            background: "#1a1205",
            border: "1px solid #ffaa00",
            borderRadius: 12,
            padding: 15,
            marginTop: 10
          }}
        >
          <div style={{ color: "#ffaa00", fontWeight: "bold", marginBottom: 6 }}>
            ⚠️ Zone technique
          </div>
          <div style={{ color: "#d8c18a", fontSize: 12 }}>
            Les actions dangereuses comme reset coins, suppression cache ou purge seront ajoutées après validation backend.
          </div>
        </div>

        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            background: "#007bff",
            padding: 12,
            borderRadius: 8,
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            width: "100%",
            marginTop: 16,
            cursor: "pointer"
          }}
        >
          ← Retour Admin
        </button>
      </div>
    </div>
  );
}

export default AdminToolsWebPage;
